var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_1354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 5.89495V13.8811C22 20.1901 17.4847 25.6614 11.5781 25.9843C7.06151 26.2312 3.11227 23.5655 1.20939 19.5978C9.23132 8.24568 18.6498 5.74567 21.284 5.25208C21.6599 5.18168 22 5.48793 22 5.89495ZM8.98052 8.06563C5.66793 5.80994 2.10381 5.29367 0.661589 5.17569C0.304333 5.14635 0 5.44347 0 5.82559V14.2668C0 15.0966 0.0898333 15.9028 0.243467 16.6841C3.12889 12.886 6.14656 10.1044 8.98052 8.06563ZM11.2793 6.74953C13.2081 5.57606 14.9907 4.75198 16.5222 4.16635C15.2915 2.60476 13.4988 1.21057 11.2781 0.0665548C11.1056 -0.0223586 10.8939 -0.0220978 10.7215 0.0668156C8.65773 1.13 6.96312 2.40933 5.7453 3.83781C7.18862 4.32632 8.76614 5.03814 10.3025 6.08425L11.2793 6.74953Z",
    fill: "#6EBD4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_1354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudd);
export default __webpack_public_path__ + "static/media/budd.5c1d8d08209b674eb2aa54b539961568.svg";
export { ForwardRef as ReactComponent };